export default "__VITE_ASSET__CmFEw119__"